var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cell-user-role"},_vm._l((_vm.roles),function(role){return _c('span',{key:role,staticClass:"role-badge",class:_vm.getBadgeClass(role)},[_vm._v("\n        "+_vm._s(_vm.getRoleLabel(role))+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }